module.exports = __webpack_public_path__ + "affordability.svg?5d0d879a7fc6f4637d024bcc964a0e5e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/affordability.svg
// module id = 274
// module chunks = 2